import React from 'react';

const DeleteIcon = () => {
	return (
		<svg
			width='14'
			height='14'
			viewBox='0 0 14 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M3 3L11 11M11 3L3 11'
				stroke='white'
				strokeWidth='1.8'
				strokeLinecap='round'
			/>
		</svg>
	);
};

export default DeleteIcon;
